<script setup lang="ts">
import useEventStore from "~/stores/event";

export interface EventBlockProps {
  event: IModelEvent | null;
}

const props = defineProps<EventBlockProps>();
const eventStore = useEventStore();
const showEventInfo = computed(() => Boolean(!eventStore.isCreatingClip && !eventStore.tags.isCreatingTag));
</script>

<template>
  <div class="rounded-main overflow-hidden">
    <template v-if="props.event">
      <EventBlockVideo :event="props.event" />
      <EventInfo v-if="showEventInfo" :event="props.event" />
    </template>
  </div>
</template>
